import s from './BackgroundImageAuthPageTopPosition.module.css';
const BackgroundImageAuthPageTopPosition = () => {
  return <div className={s.backgroundImageTop} />;
};

export default BackgroundImageAuthPageTopPosition;
